function IconX() {
    return (
        <svg viewBox="0 0 40 40">
            <path d="M8 8 32 32M32 8 8 32" stroke="currentColor" stroke-width="7" stroke-linecap="round" fill="none" />
        </svg>
    );
}

export default IconX;